export { default as translations } from './translations.json';

const RECENT_SEARCHES_KEY = 'recentSearches';
const MAX_RECENT = 10;

/**
 * Save a search term to localStorage recent searches.
 * @param {string} query
 */
export const saveRecentSearch = (query) => {
  if (typeof localStorage === 'undefined' || !query?.trim()) return;
  try {
    const current = JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) || '[]');
    const updated = [query.trim(), ...current.filter(q => q !== query.trim())].slice(0, MAX_RECENT);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updated));
  } catch (_) {}
};

/**
 * Get recent searches from localStorage.
 * @returns {string[]}
 */
export const getRecentSearches = () => {
  if (typeof localStorage === 'undefined') return [];
  try {
    return JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) || '[]');
  } catch (_) {
    return [];
  }
};

/**
 * Clear recent searches.
 */
export const clearRecentSearches = () => {
  if (typeof localStorage !== 'undefined') localStorage.removeItem(RECENT_SEARCHES_KEY);
};
